<!-- 登陆页面 -->
<template>
    <div class="login-wrap">
        <div class="login-cont">
            <div class="cont-header">
                <i class="header-ico el-icon-arrow-left" @click="goBack"></i>
            </div>
            <div class="cont-main">
                <div class="info-box">
                    <div class="pic-top"><img src="../../../assets/icons/login/weixin2.png" alt=""></div>
                    <p class="info-middle">绑定微信</p>
                    <p class="tip-bottom">您还未绑定微信</p>
                </div>
                <!-- <div class="info-box">
                    <div class="pic-top"><img src="../../../assets/icons/login/weixin2.png" alt=""></div>
                    <p class="info-middle">Lucky 小公举</p>
                    <p class="tip-bottom">您已绑定微信</p>
                </div> -->
                <!-- 表单 -->
                <div class="form-box new-margin">
                    <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0px" class="login-form">
                        <div class="login-btn">
                            <el-button type="primary" @click="">马上绑定
                            </el-button>
                        </div>
                        <!-- <div class="login-btn">
                            <el-button type="primary" @click="">解除绑定
                            </el-button>
                        </div> -->
                    </el-form>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import loginApi from '@/resources/loginModule/login'
    import config from '@/config'

    export default {
        data: function () {
            return {
                //表单数据
                loginForm: {
                    userName: "",
                    pwd: "",
                    tel: "",
                    code: ""
                },
            };
        },
        computed: {},
        created() { },
        mounted() { },
        methods: {
            goBack() {
                this.$router.back()
            },
            toLogin() {
                this.$router.push({ path: "/app/login" });
            },

        }
    };
</script>

<style scoped>
    @import "../../../assets/css/login/loginapp.css";
</style>